import {SEARCH_USER_REQUEST} from './constants';
import {Profile} from 'feedback-system/dto/IProfile';

export interface GetSearchUsersAction {
    type: string;
    endpoint: string;
    getUsers: (users: Profile[] | null) => void;
    setError: () => void;
}

export const getSearchUsersAction = (
    endpoint: string,
    getUsers: (users: Profile[] | null) => void,
    setErorr: () => void
) => ({
    type: SEARCH_USER_REQUEST,
    endpoint,
    getUsers,
    setErorr
});
